<div class="maintenance-modal">
  <div class="maintenance-content">
    <div class="sleepy-gallix"></div>
    <div class="maintenance-message">
      <h2>We are currently under the hood...</h2>
      <p>Our system is currently undergoing maintenance.<br> Please check back later.</p>
      <div class="maintenance-timer">
        <div class="timer-label">Maintenance expected to end in:</div>
        <div class="timer-value">{{ timeRemaining }}</div>
        <div class="timer-exact">{{ (endDate | gallixDate:'DATETIME_MEDIUM') | ngrxPush }}</div>
      </div>
    </div>
  </div>
</div>
